var DeviceTypes;
(function (DeviceTypes) {
    DeviceTypes["Desktop"] = "Desktop";
    DeviceTypes["Tablet"] = "Tablet";
    DeviceTypes["Mobile"] = "Mobile";
})(DeviceTypes || (DeviceTypes = {}));
let deviceType = 'Unknown';
let osType = 'Unknown';
const getDeviceType = (userAgent) => {
    if (deviceType !== 'Unknown' && osType !== 'Unknown') {
        return { deviceType, osType };
    }
    let ua = userAgent;
    if (typeof window !== 'undefined') {
        ua = navigator.userAgent;
    }
    if (/Mobi|Android/i.test(ua)) {
        deviceType = 'Mobile';
        // eslint-disable-next-line max-depth
        if (/Tablet|iPad/i.test(ua)) {
            deviceType = 'Tablet';
        }
    }
    else if (/Intel Mac/i.test(ua) && navigator.maxTouchPoints > 0) {
        deviceType = 'Tablet';
    }
    else {
        deviceType = 'Desktop';
    }
    if (/Mac OS|iOS|like Mac OS X/i.test(ua)) {
        osType = 'iOS';
        if (/Intel Mac/i.test(ua)) {
            osType = 'Mac OS';
        }
    }
    else if (/Windows NT/i.test(ua)) {
        osType = 'Windows';
    }
    else if (/Android/i.test(ua)) {
        osType = 'Android';
    }
    else if (/Linux/i.test(ua)) {
        osType = 'Linux';
    }
    return { deviceType, osType };
};

export { DeviceTypes, getDeviceType };
